import { FC } from "react";
import DailyMotion from "../components/DailyMotion";
import ArticleImage from "../ArticleImage";
import YouTube from "../components/YouTube/YouTube";

type Props = {
  hero: any;
  isHeroOverride?: boolean;
  isHero: boolean;
};

const HeroSelector: FC<Props> = ({ hero, isHeroOverride, isHero }) => {
  switch (hero.type) {
    case "dailymotion":
      return <DailyMotion data={hero.data} />;
    case "youtube":
    case "video-youtube":
      return <YouTube data={hero.data} />;
    case "image":
      return (
        <ArticleImage
          image={hero.data}
          isHeroOverride={isHeroOverride}
          isHero={isHero}
        />
      );
    default:
      return null;
  }
};

export default HeroSelector;
